<template>
  <div class="header-box">
    <el-row type="flex" justify="space-between">
      <el-col :span="6">
        <button class="btn-tool" title="折叠" @click="collapse" >
            <i class="el-icon-d-arrow-left"></i>
        </button>
        <button class="btn-tool" title="全屏" @click="Utils.fullScreen">
            <i class="el-icon-rank"></i>
        </button>
      </el-col>
      <el-col align="right">
        <span>{{ Utils.todayDate() }}</span>
        <el-dropdown trigger="click" class="user-name" @command="handleCommand">
          <span class="el-dropdown-link">
            {{username}}<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { logout } from '@/api'
export default {
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    username() {
      return sessionStorage.getItem('username') || ''
    }
  },
  methods: {
    collapse() {
      this.$store.commit('switchCollapse')
    },
    logout() {
      logout().then(res => {
        this.$router.replace({ path: '/login' })
      })
    },
    handleCommand(command) {
      switch (command) {
        case 'logout':
          this.logout()
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-tool {
  border: none;
  background: transparent;
  font-size: 18px;
  padding: 5px 10px;
  cursor: pointer;
  outline: none;
  text-align: left;
}
.user-name {
  margin-left: 20px;
}
</style>
